import React from 'react';
import {
  List, Datagrid, TextField, RichTextField, Edit,
  Show,
  EmailField,
  SimpleShowLayout,
  Create,
  SimpleForm,
  TextInput,
  ShowButton,
  ReferenceInput,
  AutocompleteInput,
  Filter,
  Pagination,
  required,
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';

const ClientFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label="Name" source="name" reference="clients" allowEmpty alwaysOn>
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput label="E-Mail" source="email" reference="clients" allowEmpty alwaysOn>
      <AutocompleteInput optionText="email" />
    </ReferenceInput>
  </Filter>
);

const ClientPagination = (props) => (
  <Pagination rowsPerPageOptions={[50, 100, 200, 500]} {...props} />
);

export const ClientList = (props) => (
  <List
    {...props}
    filters={<ClientFilter />}
    pagination={<ClientPagination />}
    perPage={50}
  >
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <EmailField source="email" />
      <ShowButton />
    </Datagrid>
  </List>
);

export const ClientEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput disabled source="id" />
      <TextInput source="name" validate={required()} />
      <RichTextInput source="description" />
      <TextInput source="email" />
    </SimpleForm>
  </Edit>
);

export const ClientCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" validate={required()} />
      <RichTextInput source="description" />
      <TextInput source="email" />
    </SimpleForm>
  </Create>
);

export const ClientShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <RichTextField source="description" />
      <EmailField source="email" />
    </SimpleShowLayout>
  </Show>
);
